export enum GlobalFilterKeys {
  Outstanding = 1,
  InMyCourt = 2,
  Overdue = 3,
  DueSoon = 4,
  Mine = 5,
  AssignedToMe = 6,
  Closed = 7,
  CreatedByMe = 8,
  LastWeek = 9,
  LastMonth = 10,
}
